<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <router-link :to="{ name: 'Home' }" class="btn btn-sm btn-outline-secondary mr-3">
          <i class="fas fa-arrow-left mr-1"></i> Back
        </router-link>
        <router-link :to="{name: 'manageMobileUsers'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Manage Mobile Users
        </router-link>
        <user-data></user-data>
      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Surveyor List</h3>
                </div>
                <div class="col text-right">
                    <b-button variant="primary" @click="editFlag = false" v-b-modal.addUsers>Add User</b-button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table class="mt-3" striped hover :items="survoyorList.data" :fields="fields">
                <template slot="index" slot-scope="data">
                  {{data.index + 1}}
                </template>
                <template slot="surveyor_login_id" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="name" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="email" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="last_login" slot-scope="data">
                  {{data.value ? data.value : ''  | moment('DD MMM YYYY h:mm a')}}
                </template>
                <template slot="status" slot-scope="data">
                  <label class="custom-toggle">
                    <input type="checkbox" v-model="data.value" @click="toggleUsers(data)">
                    <span class="custom-toggle-slider rounded-circle"></span>
                  </label>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-link @click='editAddress(data.item)' class="text-primary"><i class="far fa-edit mr-2"></i></b-link>
                  <!-- <b-link @click='deleteAddress(data.item.lotNo)' class="text-danger"><i class="far fa-trash-alt mr-2"></i></b-link> -->
                </template>
              </b-table>

              <div class="card-footer border-0 my-2" v-if="pagination.total != 0">
                <b-pagination align="right" @input="pageClick(currentPage)" :total-rows="pagination.total" v-model="currentPage" :per-page="10">
                </b-pagination>
              </div>
            </div>
            <div v-show="pagination.total == 0">
              <h4 class="py-5 text-center">No records available</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add mobile User Modal -->
    <b-modal no-close-on-backdrop no-close-on-esc ref="addUsers" size="lg"  id="addUsers" centered hide-footer :title="editFlag ? 'Edit mobile user' : 'Add mobile user'">
      <b-form @submit.prevent="formSubmit(form)">
        <div class="row">
          <b-form-group id="survoyorName" label="Surveyor Name" label-for="survoyorName" class="col-md-6">
            <b-form-input id="survoyorName" type="text" v-model="form.name" 
              placeholder="Enter surveyor name">
            </b-form-input>
          </b-form-group>
          <!-- <b-form-group id="phone_no" label="Phone Number" label-for="phone_no" class="col-md-6">
            <b-form-input id="phone_no" type="number" v-model="form.phone_no" 
              placeholder="Enter phone number">
            </b-form-input>
          </b-form-group> -->
        </div>
        <div class="row">
          <!-- <b-form-group id="loginId" label="Login Id" label-for="loginId" class="col-md-6">
            <b-form-input id="loginId" type="text" v-model="form.surveyor_login_id" 
              placeholder="Enter login id">
            </b-form-input>
          </b-form-group> -->
          <b-form-group id="email" label="Email Id" label-for="email" class="col-md-6">
            <b-form-input id="email" type="email" v-model="form.email" 
              placeholder="Enter email id">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group id="password" label="Password" label-for="password" class="col-md-6">
            <b-form-input id="password" type="password" v-model="form.password" 
              placeholder="Enter password">
            </b-form-input>
          </b-form-group>
          <b-form-group id="confirmPassword" label="Confirm Password" label-for="confirmPassword" class="col-md-6">
            <b-form-input id="confirmPassword" type="password" v-model="form.confirmPassword" 
              placeholder="Enter repeat password">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-md-6 text-center">
            <b-button type="submit" variant="success">Submit</b-button>
            <b-link @click="hideModal()">Cancel</b-link>
          </div>
        </div>
      </b-form> 
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData';

  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        pagination: {},
        currentPage: 1,
        editFlag: false,
        form : {
          name: null,
          // phone_no: null,
          // surveyor_login_id: null,
          email: null,
          password: null,
          confirmPassword: null
        },
        fields: [
          'index',
          {
            key: 'name',
            label: 'Surveyor Name',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'email',
            label: 'Email',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'last_login',
            label: 'Last Login',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'status',
            label: 'Status',
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
      }
    },
    computed: {
      ...mapGetters('survoyor', ['survoyorList'])
    },
    methods: {
      ...mapActions('survoyor', ['SURVOYOR_LIST', 'ADD_SURVOYOR', 'UPDATE_SURVOYOR', 'TOGGLE_USERS']),
      getSurvoyorList () {
        return this.SURVOYOR_LIST().then(() => {
          this.pagination = this.survoyorList.meta.pagination;
        }).catch(() => {})
      },
      formSubmit(data) {
        console.log(data)
        if(!data.name) {
          this.ERROR_TOAST_MSG('Please enter name');
        // } else if(!data.phone_no) {
        //   this.ERROR_TOAST_MSG('Please enter phone number');
        } else if(!data.email) {
          this.ERROR_TOAST_MSG('Please enter email id');
        } else if(!data.password && !this.editFlag) {
          this.ERROR_TOAST_MSG('Please enter password');
        } else if((data.password !== data.confirmPassword) && !this.editFlag) {
          this.ERROR_TOAST_MSG('password miss match');
        } else {
          if(!this.editFlag) {
            this.ADD_SURVOYOR(data).then(()=>{
              this.editFlag = false
              this.hideModal()
              this.getSurvoyorList ()
            }).catch(() => {
              
            })
          } else {
            let updateData = {
              id: data.id,
              // surveyor_login_id: data.surveyor_login_id,
              name: data.name,
              email: data.email,
              // phone_no: data.phone_no
            }
            if(data.password != undefined || data.password) {
              updateData.password= data.password
            }
            console.log(updateData)
            this.UPDATE_SURVOYOR(updateData).then(()=>{
              this.editFlag = false
              this.hideModal()
              this.getSurvoyorList ()
            }).catch(() => {
              
            })
          }
          
        }
      },
      editAddress(data) {
        this.editFlag = true
        this.$refs.addUsers.show()
        this.form = data
      },
      toggleUsers (data) {
        let userSendData = {
          mobile_user_id: data.item.id
        }
        this.TOGGLE_USERS(userSendData).then(() => {
          this.getSurvoyorList()
        })
      },
      pageClick(pageNo) {
        this.SURVOYOR_LIST({ page: pageNo }).then(() => {
          this.pagination = this.survoyorList.meta.pagination
        }).catch(() => {})
      },
      hideModal() {
        this.$refs.addUsers.hide()
        this.form = {
          name: null,
          // phone_no: null,
          // surveyor_login_id: null,
          email: null,
          password: null,
          confirmPassword: null
        }
      }
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }

        this.getSurvoyorList().then(() => {
          if (this.$route.query.new === '1') {
            this.editFlag = false
            this.$refs.addUsers.show()
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/manageMobileUsers.vue